import RoomPicker from './RoomPicker'

export default class BookingForm {
  constructor($form) {
    this.$form = $form
    // Init Datepicker
    this.initDatepicker()

    // Init RoomPicker
    this.initRoompicker()

    // Buscar (submit)
    // this.$form.on('submit', this.onSubmit.bind(this))
  }

  config(key) {
    let config = {
      dateFormat: 'dd-mm-yy',
      monthNames: ['January','February','March','April','May','June','July','August','September','October','November', 'December'],
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      firstDay: 1,
    }

    return config[key]
  }

  /**
   * Init DatePicker
   */
  initDatepicker() {
    let $start = this.$form.find('[name="datein"]')
    let $end = this.$form.find('[name="dateout"]')

    $start.datepicker(this.configDatepicker()).on('change', () => {
      setTimeout(() => {$end.val('');$end.focus()}, 100)
    })

    $end.datepicker(this.configDatepicker())

    // let start_picker = $start.datepicker(this.configDatepicker()).on('change', () => {
    //   let min_date = this.addDaysToDate(1, this.getDateFromPicker(start_picker))
    //   end_picker.datepicker('option', 'minDate', min_date)

    //   setTimeout(() => {$end.focus()}, 100)
    // })

    // let end_picker = $end.datepicker(this.configDatepicker()).on('change', () => {
    //   let max_date = this.addDaysToDate(-1, this.getDateFromPicker(end_picker))
    //   start_picker.datepicker('option', 'maxDate', max_date)
    // })
  }
  
  /**
   * DatePicker configuration
   */
  configDatepicker() {
    return {
      dateFormat: this.config('dateFormat'),
      monthNames: this.config('dateMonts'),
      dayNamesMin: this.config('dayNamesMin'),
      dayNames: this.config('dayNames'),
      firstDay: this.config('dayfirstDay'),
      changeMonth: false,
      changeYear: false,
      numberOfMonths: ($(window).width() < 768) ? 1 : 2,
      minDate: this.addDaysToDate(0),
      // maxDate: this.addDaysToDate(360), // 365 - 5
    }
  }

  /**
   * Get today plus days
   *
   * @param {number} days
   * @param {Date} days
   */
  addDaysToDate(days = 0, date = null) {
    if (! date) date = new Date()

    date.setDate(date.getDate() + parseInt(days))

    return this.config('dateFormat')
            .replace('dd', date.getDate())
            .replace('mm', date.getMonth() + 1)
            .replace('yy', date.getFullYear())
  }/**
   * Get date on "from" DatePicker
   *
   * @param {number} date_picker
   */
  getDateFromPicker(date_picker) {
    try {
      return $.datepicker.parseDate( this.config('dateFormat'), date_picker.val() );
    } catch( error ) {
      //
    }

    return null;
  }

  /**
   * Init RoomPicker
   */
  initRoompicker() {
    this.roomPicker = new RoomPicker(this.$form.find('.roompicker'))
  }

}



// WEBPACK FOOTER //
// ./scripts/components/BookingForm.js